<form [formGroup]="approveForm">
    <div class="modal-header">
        <h4>{{ displayData?.title }}</h4>
        <a class="close-icon" href="javascript:void()" (click)="closeModal()" ngbAutofocus><i class="flaticon2-cross"></i></a>
    </div>
    <div class="modal-body output-lable">
        <div class="row align-items-center justify-content-between">
            <div class="col-md-12 text-end">
                <div class="activity_title_wrapper d-flex align-items-center justify-content-end w-100">
                    <span class="activity_title">{{ 'SETTING_PAGE.IDMS_SETTINGS.ITEM_NAME' | transloco }}</span>
                    <span class="section-data">{{ data?.name }}</span>
                    <span class="activity_title">{{ 'SETTING_PAGE.IDMS_SETTINGS.ITEM_TYPE' | transloco }}</span>
                    <span class="section-data">{{ data?.item?.value }}</span>
                </div>
            </div>

            <div class="col-md-12">
                <p>{{ displayData?.label1 }}</p>
            </div>
        </div>
        <br />
        <div class="row align-items-center justify-content-between">
            <div class="col-md-3">
                <p>{{ displayData?.label2 }}</p>
            </div>
            <div class="col-md-9">
                <textarea
                    class="input-form-class"
                    formControlName="comments"
                    matInput
                    type="text"
                    rows="4"
                    placeholder="{{ 'INFORMATE_HEADER.JCC.COMMENTS' | transloco }}"
                    name="comments"
                ></textarea>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn primary-ebtn" (click)="Submit()" [disabled]="!approveForm.valid">{{ displayData?.btnText }}</button>
        <button type="button" class="btn secondary-ebtn" (click)="closeModal()">{{ 'SETTING_PAGE.IDMS_SETTINGS.CANCEL' | transloco }}</button>
    </div>
</form>
